import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { ISearchResponse } from '@models/scraperModel/searchModel';
import { axiosScraper } from '@utils/axios/axiosInstance';

export const fetchAppPublisherInfo = createAsyncThunk(
  'fetchAppPublisherInfo',
  async (params: { devId: string; provider_type: string }) => {
    try {
      const { provider_type, devId } = params;
      const { data, status } = await axiosScraper.post(`/${provider_type}/developer`, {
        devId,
      });
      if (status === 200) {
        console.log('fetchAppPublisherInfo Data: ', data);
        return data;
      }
    } catch (error) {
      console.log('fetchAppPublisherInfoError: ', error);
    }
  }
);
